import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationPolicyCreatev2Args, Policy } from "types/generated";

type CreatePolicyData = Pick<Policy, "id" | "name" | "labels" | "space">;

/* eslint-disable @cspell/spellchecker */
export const CREATE_POLICY_V2: TypedDocumentNode<
  { policyCreatev2: CreatePolicyData },
  MutationPolicyCreatev2Args
> = gql`
  mutation CreateLoginPolicyV2($input: PolicyCreateInput!) {
    policyCreatev2(input: $input) {
      id
      name
      labels
      space
    }
  }
`;
/* eslint-enable @cspell/spellchecker */

export const GET_ACCOUNT_AUTH_SCHEME = gql`
  query GetAccountAuthScheme {
    authorizationScheme
  }
`;
